<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ct"><a href="#/APerfectSecreteBook2">Glossary</a></p>
<p class="glo"><em class="i">ab im kopp</em>—off in the head, crazy</p>
<p class="glo"><em class="i">ach—</em>oh</p>
<p class="glo"><em class="i">aenti</em>—aunt</p>
<p class="glo"><em class="i">appeditlich—</em>delicious</p>
<p class="glo"><em class="i">bensel—</em>hard to handle; a handful</p>
<p class="glo"><em class="i">bruder</em>—brother</p>
<p class="glo"><em class="i">daadi haus</em>—a small house built onto or near the main house for grandparents to live in</p>
<p class="glo"><em class="i">daag</em>—day</p>
<p class="glo"><em class="i">daed</em>—dad</p>
<p class="glo"><em class="i">danki</em>—thanks</p>
<p class="glo"><em class="i">Derr Herr</em>—God</p>
<p class="glo"><em class="i">dochder</em>—daughter</p>
<p class="glo"><em class="i">dumm</em>—dumb</p>
<p class="glo"><em class="i">dummkopf</em>—dummy</p>
<p class="glo"><em class="i">eck</em>—special place for bride and groom at the corner of the wedding table</p>
<p class="glo"><em class="i">Englisch</em>—non-Amish</p>
<p class="glo"><em class="i">Englischer</em>—a non-Amish person</p>
<p class="glo"><em class="i">familye</em>—family</p>
<p class="glo"><em class="i">frau</em>—wife</p>
<p class="glo"><em class="i">freind</em>—friend</p>
<p class="glo"><em class="i">geh</em>—go</p>
<p class="glo"><em class="i">gut</em>—good</p>
<p class="glo"><em class="i">haus</em>—house</p>
<p class="glo"><em class="i">hiya—</em>hello</p>
<p class="glo"><em class="i">kaffee</em><em class="i">—</em>coffee</p>
<p class="glo"><em class="i">kapp</em>—prayer covering or cap</p>
<p class="glo"><em class="i">kinn, kinner</em>—child, children</p>
<p class="glo"><em class="i">kumme</em>—come</p>
<p class="glo"><em class="i">lieb</em>—love</p>
<p class="glo"><em class="i">maedel </em>or<em class="i"> maed</em>—girl or girls</p>
<p class="glo"><em class="i">mamm</em>—mom</p>
<p class="glo"><em class="i">mann</em>—man, men</p>
<p class="glo"><em class="i">mei</em>—my</p>
<p class="glo"><em class="i">milch—</em>milk</p>
<p class="glo"><em class="i">mudder</em>—mother</p>
<p class="glo"><em class="i">narrisch</em>—crazy</p>
<p class="glo"><em class="i">nee</em>—no</p>
<p class="glo"><em class="i">nix</em>—nothing</p>
<p class="glo"><em class="i">onkel</em>—uncle</p>
<p class="glo"><em class="i">roascht—</em>bread stuffing and chicken baked in a casserole</p>
<p class="glo"><em class="i">rumschpringe</em>—running-around period when a teenager turns sixteen years old</p>
<p class="glo"><em class="i">schee</em>—handsome</p>
<p class="glo"><em class="i">schwester</em>—sister</p>
<p class="glo"><em class="i">seltsam</em>—weird</p>
<p class="glo"><em class="i">sohn</em>—son</p>
<p class="glo"><em class="i">was in der welt—</em>what in the world</p>
<p class="glo"><em class="i">wunderbaar</em>—wonderful</p>
<p class="glo"><em class="i">ya</em>—yes</p>
<p class="glo"><em class="i">Yankee—</em>non-Amish person, term used in Middlefield, Ohio</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// APerfectSecreteBook5.vue?2cae231b